"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Link.default;
  }
});

var _Link = _interopRequireDefault(require("./Link"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Link/index.js
// module id = 309
// module chunks = 0